import { Component } from "react";

class SchoolTrust extends Component {
  render() {
    return (
      <>
        <section className="py-5 my-lg-5 bg-white">
          <div className="container">
            <div className="row mb-5 g-4 align-items-start">
              <div className="col-lg-6">
                <h2 className="display-5 text-brand fw-medium">
                  Partnering Schools
                  <br />
                  for the Future
                </h2>
              </div>
              <div className="col-lg-6">
                <p className="lead text-secondary">
                  We partner with{" "}
                  <span className="text-brand fw-bold">
                    schools across world
                  </span>
                  —from{" "}
                  <span className="text-brand fw-bold">emerging schools</span>{" "}
                  to{" "}
                  <span className="text-brand fw-bold">
                    established institutions
                  </span>
                  —helping them navigate the complexities of STEAM education,
                  sharpen their academic strategy, and accelerate student
                  outcomes.
                </p>
              </div>
            </div>

            <div className="row g-5">
              <div className="col-lg-5">
                <p className="text-secondary" style={{ lineHeight: "1.8" }}>
                  This vision has led to the creation of the{" "}
                  <strong>Xperiential Learning Program (XLP™)</strong>—a{" "}
                  <strong>holistic, turn-key skill framework</strong> for
                  schools. Fully aligned with <strong>NEP 2020</strong> and
                  adaptable across{" "}
                  <strong>CBSE, IB, IGCSE, ICSE, and State Boards</strong>, XLP
                  is designed to complement and enhance academics without adding
                  extra burden.
                </p>
              </div>

              <div className="col-lg-7">
                <div className="row g-3 text-white">
                  <div className="col-md-4">
                    <div className="bg-brand p-4 rounded-3 h-100">
                      <h3 className="display-5 mb-1">1000+</h3>
                      <p className="mb-0">schools</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="bg-brand p-4 rounded-3 h-100">
                      <h3 className="display-5 mb-1">200K+</h3>
                      <p className="mb-0">students</p>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="bg-brand p-4 rounded-3 h-100">
                      <h3 className="display-5 mb-1">700+</h3>
                      <p className="mb-0">
                        hours of Skill
                        <br />
                        Modules
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="bg-brand p-4 rounded-3 h-100">
                      <h3 className="display-5 mb-1">300+</h3>
                      <p className="mb-0">real Projects</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="bg-brand p-4 rounded-3 h-100">
                      <h3 className="display-5 mb-1">07+</h3>
                      <p className="mb-0">countries</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default SchoolTrust;
